<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.xxzj" alt>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">行星轧机</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
      <p>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#2F3032;"
        >我公司提供的三辊行星轧机达到了当代国际先进水平，是管、棒材加工的理想设备，可用于冷轧紫铜、热轧黄铜和黑色金属材料的开坯轧制。利用行星轧的制方法在一个道次上可完成</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">90%</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">以上的截面变形量。如三辊行星轧机轧制连铸铜管时的变形系数可达</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">15</span>
        <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">以上，铸造结构可以得到实质性改变。</span>
        <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
          <br>
        </span>
      </p>
      <p>
        <strong>
          <span style="font-size:12.0pt;font-family:宋体;color:#2F3032;">设备组成：</span>
        </strong>
        <b>
          <span style="font-size:12.0pt;font-family:Arial;color:#2F3032;">
            <br>
          </span>
        </b>
        <span
          style="font-size:12.0pt;font-family:宋体;color:#2F3032;"
        >本机组由上料系统、三辊行星轧管机、出料系统等组成，并配有相应的电控、液压、润滑、冷却及气动系统。</span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        xxzj: require("../../../assets/img/common/xxzj.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/device/xxzj.vue